import { hasValue } from '../../internal';
import { valueLessThanMinValue } from '../utils';
export const minValueRule = (params, value) => {
  const results = typeof value === 'string' || typeof value === 'number' ? hasValue(value) && valueLessThanMinValue(value, params.minValue) : false;
  const ruleResults = {
    validationState: {
      isValid: true,
      type: undefined,
      messageKey: 'lessThanMinValue'
    },
    triggered: false
  };
  if (results) {
    ruleResults.validationState.isValid = !results;
    ruleResults.triggered = results;
    ruleResults.validationState.type = 'error';
    ruleResults.validationState.message = results ? params.customErrorMessages?.lessThanMinValue || `'${value}' is less than the minimum value of ${params.minValue}` : undefined;
  }
  return ruleResults;
};